import React from 'react';
import {CustomFieldType, CbsFieldGroup} from '../../../shared/model/custom-field-type.model';
import {CustomerType} from '../../../shared/model/customer-type.model';
import useExternalCustomFieldConfig, {
  ExternalCustomFieldConfigSearchRequest
} from '../../loan-applications/loan-application/steps/customer-data/hooks/use-custom-field-config-query.hook';
import {ExternalCustomFieldSelectableList} from './ExternalCustomFieldSelectableList';

interface Props {
  handleSave: (externalCustomFieldConfigId?: number) => void;
  externalCustomFieldConfigId?: number;
  externalCustomFieldConfigSearchRequest: ExternalCustomFieldConfigSearchRequest;
}

export interface ExternalCustomFieldConfig {
  id: number;
  sourceKey: string;
  availableInBranchIds: number[];
  customerTypes: CustomerType[];
  customFieldGroup: CbsFieldGroup;
  name: string;
  enabled: boolean;
  required: boolean;
  fieldType: CustomFieldType;
  categories: ExternalCustomFieldConfigCategory[];
}

interface ExternalCustomFieldConfigCategory {
  id: number;
  parentName: string;
  name: string;
  code: string;
  fullName: string;
}

export default function ExternalCustomFieldSelection({
                                                       handleSave,
                                                       externalCustomFieldConfigId,
                                                       externalCustomFieldConfigSearchRequest
                                                     }: Props): React.ReactElement {
  const { externalCustomFieldConfigs, areCustomConfigLoaded } = useExternalCustomFieldConfig(
    externalCustomFieldConfigSearchRequest
  );

  if (!areCustomConfigLoaded) {
    return <div>Loading...</div>;
  }

  const handleSelectionChange = (key?: number) => {
    handleSave(key);
  };

  return (
    <ExternalCustomFieldSelectableList
      externalCustomFieldConfigs={externalCustomFieldConfigs || []}
      externalCustomFieldConfigId={externalCustomFieldConfigId}
      onSelectionChange={handleSelectionChange}
    />
  );
}